<template>
<b-modal id="modal-create" size="lg" title="Create Game">
    <div class="row justify-content-center mt-4">
        <div class="col-8 text-center mb-4">
            NOTE: The entire price gets added to the game reward pool, which the winning play will receive 
            upon completion of the game. Currently, there are 3 game grid-sizes - 4x4 (16 pieces), 4x3 (12 pieces) 
            and 4x2 (8 pieces).
        </div>
        <div class="col-8">
            <input v-model="price" type="number" class="form-control mt-3" placeholder="Price to Play"/>
            <b-form-select v-model="selected" :options="options" class="mt-3"/>
        </div>       
    </div>
    <div slot="modal-footer" class="text-center">        
        <button type="button" class="btn btn-secondary" @click="hideModal">
            {{ 'CLOSE' | translate }}
        </button>
        <button type="button" @click="newGame" class="btn btn-primary">
            {{ 'Create' | translate }}
        </button>
    </div>
</b-modal>    
</template>
 
<script>
import { mapGetters } from "vuex";

export default {
  name: "modal-grid",
  components: { },
    data () {
        return {
            price: null,
            reward: null,
            maxGuesses: null,
            gridSize: null,
            selected: null,
            options: [
                { value: null, text: 'Grid Size' },
                { value: 16, text: '4 x 4 - 16 Positions', selected: true },
                { value: 12, text: '4 x 3 - 12 Positions' },
                { value: 8, text: '4 x 2 - 8 Positions' }
            ]
        }
    },
    computed: {
        ...mapGetters({
        
        }),
        today () {
            return this.$moment(new Date()).format('MM/DD/YYYY');
        }
    },
    methods: {
        hideModal () {
            this.$root.$emit('bv::hide::modal','modal-create');
        },

        _newGameSecurity (price, gridSize) {

            if (!price || parseInt(price) < 0) {

                this.$notify({
                    group: "app",
                    title: "Warning!",
                    text: 'Price is required and cannot be less than 0!'
                });
                return false;

            }  
            
            if (!gridSize) {

                this.$notify({
                    group: "app",
                    title: "Warning!",
                    text: 'You must enter a player allowance!'
                });
                return false;

            }  
            
            return true;

        },

        newGame () {

            const price = this.price;
            const gridSize = this.selected;

            if (!this._newGameSecurity(price, gridSize)) return;
            const payload = { price, gridSize };

            this.$store.commit('updatePendingTransaction', { status: true });
            this.$store.dispatch('newGame', payload).then((response) => {

                if (response.message == 'success') {

                    this.$notify({
                        group: "app",
                        title: "Success!",
                        text: 'You have created a new game!'
                    });

                } else if (response.message == 'error') {

                    this.$notify({
                        group: "app",
                        title: "Warning!",
                        text: 'There was an error with your transaction'
                    });

                } else {

                    this.$notify({
                        group: "app",
                        title: "Warning!",
                        text: 'There was a problem loading your data, please refresh'
                    });

                }

                this.$store.commit('updatePendingTransaction', { status: false });

            });
            
            this.hideModal();

        }
    }
};
</script>

<style scoped lang="less">
@import "../assets/less/modal.less";
@import "../assets/less/app.less";

#modal-create .row {
    color: #fff;
}

</style>


// WEBPACK FOOTER //
// src/components/ModalCreate.vue